class BundleFilterNav extends HTMLElement {
	connectedCallback() {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
		} else {
			this.init();
		}
	}

	init() {
		const sectionId = this.dataset.sectionId;
		this.filters = window.BundleBuilder?.[sectionId]?.filters || [];

		if (this.filters.length < 2) return;

		this.render();
		this.activateFilter(this.filters[0]);
	}

	render() {
		const nav = document.createElement('nav');
		nav.className = 'bundle-filter-nav';
		nav.setAttribute('aria-label', 'Product type filters');

		for (const filter of this.filters) {
			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'bundle-filter-nav__tab';
			button.textContent = filter.title;
			button.dataset.value = filter.value;
			button.addEventListener('click', () => this.activateFilter(filter));

			let hoverTimer = null;
			button.addEventListener('pointerenter', () => {
				if (this.activeValue === filter.value) return;
				if (navigator.connection?.saveData) return;
				hoverTimer = setTimeout(() => {
					document.dispatchEvent(
						new CustomEvent('bundle:prefetch-filter', {
							detail: { param: filter.param, value: filter.value },
						})
					);
				}, 80);
			});
			button.addEventListener('pointerleave', () => {
				clearTimeout(hoverTimer);
			});

			nav.appendChild(button);
		}

		this.appendChild(nav);
	}

	activateFilter(filter) {
		if (this.activeValue === filter.value) return;
		this.activeValue = filter.value;

		for (const tab of this.querySelectorAll('.bundle-filter-nav__tab')) {
			tab.classList.toggle('is-active', tab.dataset.value === filter.value);
		}

		document.dispatchEvent(
			new CustomEvent('bundle:filter-changed', {
				detail: { param: filter.param, value: filter.value },
			})
		);
	}
}

customElements.define('bundle-filter-nav', BundleFilterNav);
